import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';

@Injectable({providedIn: 'root'})
export class CoachStudentService {

  private apiPrefix = '/coach/students';

  constructor(
    private api: ApiService,
  ) {
  }

  /** Lean roster, used wherever a student has to be picked from a select box. */
  getStudents(queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}`, queryString);
  }

  getStudentDetail(studentId: number): Observable<any> {
    return this.api.get(`${this.apiPrefix}/${studentId}`);
  }

  /** Enriched roster: per-period level, latest scores, score trend and meeting counters. */
  getStudentsOverview(queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/overview`, queryString);
  }

  getStudentsSummary(queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/summary`, queryString);
  }

  getStudentOverview(studentId: number, queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/${studentId}/overview`, queryString);
  }

  /** The student's last exams of one exam type, oldest first, with their goal. */
  getStudentExamScores(studentId: number, queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/${studentId}/exam-scores`, queryString);
  }
}
